export default {
  companyEmployeesMetadata: {
    titles: {
      createTeam: 'Новая команда',
      changeTeam: 'Редактировать команду',
      transferTeam: 'Перенос участников команды и оценок 360',
      deleteTeam: 'Удаление команды',
      inviteEmployee: 'Новый сотрудник',
      importEmployees: 'Загрузка пользователей',
      interconnectSettings: 'Выберите сотрудников',
    },
    descriptions: {
      transferTeam:
        'Выберите участников и новые команды в которые хотите перенести оценки 360. Для переноса можно выбрать только одну команду.',
      importEmployees:
        'Идёт загрузка пользователей, пожалуйста, не закрывайте окно, если что-то пойдёт не так, то в конце мы покажем вам список ошибок.',
      interconnectSettings:
        'Выберите группу пользователей по которым будет построена диаграмма взаимодействий. Вы можете построить диаграмму по компании в целом, по команде или по определённым сотрудникам.',
    },
    buttons: {
      addEmployee: 'Добавить сотрудника',
      inviteEmployee: 'Пригласить сотрудника',
      downloadTemplate: 'Скачать шаблон xls',
      importEmployees: 'Загрузить xls',
      transferTeam: 'Перенос участников',
      createTeam: 'Создать команду',
      changeTeam: 'Редактировать команду',
      deleteTeam: 'Удалить команду',
    },
    formLabels: {
      teamName: 'Название команды',
      searchEmployees: 'ФИО сотрудника',
      authEmailsState: 'Отправка писем для авторизации',
    },
    tabs: {
      inviteByEmail: 'Пригласить по e-mail',
      searchInTheList: 'Найти в списке',
    },
    tooltips: {
      addEmployee:
        'Добавление сотрудников и команд возможно на businesschain, после чего они отобразятся в данной компании.',
      downloadTemplate: 'Скачайте шаблон для загрузки списка сотрудников в компанию',
      importEmployees: 'Загрузите заполненный шаблон для добавления сотрудников в компанию',
      authEmailsState:
        'Если выбрана опция “Отключено”, то при добавлении сотрудников в компанию, пользователям не будут отправлены письма с логином и паролем для входа на платформу.<br/><br/>Если выбрана опция “Включено”, то при включении или в момент добавления сотрудников в компанию, им будут направлены письма с логином и паролей для входа на платформу.',
      transferTeam: 'Перенос участников и оценок',
    },
    // messages
    successMessages: {
      dismissEmployee: 'Сотрудник успешно уволен',
      reinstateEmployee: 'Сотрудник успешно восстановлен',
      importEmployees:
        'Добавляемым сотрудникам будет отправлено письмо на указанные email с приглашением в компанию и временным паролем',
      importEmployeesDialog:
        'Все пользователи были успешно добавлены в компанию, вы можете закрыть это окно.',
      inviteEmployee: 'Сотруднику отправлено приглашение',
      cancelInvitationEmployee: 'Приглашение успешно отменено',
      disableAuthEmails: 'Отправка писем для авторизации отключена',
      enableAuthEmails: 'Отправка писем для авторизации включена',
      createTeam: 'Команда успешно создана',
      changeTeam: 'Команда успешно изменена',
      transferTeam: 'Сотрудники успешно перенесены',
      deleteTeam: 'Команда успешно удалена',
      deleteEmployee: 'Сотрудник успешно удален',
      checkTeamTests360:
        'В команде есть оценки 360. Для удаления команды и переноса сотрудников в новую команду обратитесь в поддержку.',
    },
    errorMessages: {
      dismissEmployee: 'Не удалось уволить сотрудника',
      reinstateEmployee: 'Не удалось восстановить сотрудника',
      importEmployees: 'Не удалось добавить сотрудников',
      importEmployeesDialog:
        'Некоторые пользователя не были загружены, пожалуйста, посмотрите список ошибок.',
      inviteEmployee: 'Не удалось пригласить сотрудника',
      cancelInvitationEmployee: 'Не удалось отменить приглашение',
      disableAuthEmails: 'Не удалось отключить отправку писем для авторизации',
      enableAuthEmails: 'Не удалось включить отправку писем для авторизации',
      diagramInNotAvailable:
        'По выбранным сотрудникам нет данных по взаимодействию за последние 30 дней. Для получения данных за другой период воспользуйтесь выгрузкой в Excel.',
      getAvailabilityDiagram: 'Не удалось проверить доступность диаграммы',
      createTeam: 'Не удалось создать команду',
      changeTeam: 'Не удалось изменить команду',
      transferTeam: 'Не удалось перенести сотрудников',
      deleteTeam: 'Не удалось удалить команду',
      deleteEmployee: 'Не удалось удалить сотрудника',
      checkTeamTests360:
        'Не удалось проверить наличие оценок 360. Для удаления команды и переноса сотрудников в новую команду обратитесь в поддержку.',
      checkStatuses: 'Не удалось проверить статус загрузки пользователей',
    },
    // confirm dialogs
    confirmDismissEmployee: {
      title: 'Уволить сотрудника?',
      text: 'Сотрудник будет исключен из всех команд компании',
      button: 'Да, уволить',
    },
    confirmInviteEmployee: {
      title: 'Отправить приглашение?',
      text: 'Данному пользователю будет направлено приглашение присоединиться к вашей компании',
      button: 'Да, отправить',
    },
    confirmReinstateEmployee: {
      title: 'Восстановить сотрудника?',
      text: 'Сотрудник будет перемещён в список действующих сотрудников компании',
      button: 'Да, восстановить',
    },
    confirmCancelInviteEmployee: {
      title: 'Отменить приглашение?',
      text: 'Если вы отмените приглашение, оно исчезнет у приглашенного пользователя',
      button: 'Да, отменить',
    },
    confirmEnableAuthEmails: {
      title: 'Вы уверены?',
      text: 'Будет включена отправка пользователям писем с данными для авторизации',
      button: 'Да, включить',
    },
    confirmDeleteTeam: {
      title: 'Удалить команду?',
      text: 'В команде есть оценки, при удалении команды оценки будут удалены без возможности восстановления. Сначала воспользуйтесь формой для переноса оценок и после вернитесь к удалению команды.',
      button: 'Всё равно удалить',
    },
    reConfirmDeleteTeam: {
      title: 'Удалить команду с оценками?',
      text: 'Вы уверены, что хотите удалить команду с оценками? Оценки нельзя восстановить, в том числе и через техническую поддержку.',
      button: 'Да, удалить',
    },
    confirmDeleteEmployee: {
      title: 'Удалить сотрудника?',
      text: 'Вы уверены, что хотите удалить сотрудника? Сотрудник будет удалён без возможности восстановления.',
      button: 'Да, удалить',
    },
    //
  },
};
